import { render, staticRenderFns } from "./SettingsWrapper.vue?vue&type=template&id=70741250&scoped=true&"
import script from "./SettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./SettingsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SettingsWrapper.vue?vue&type=style&index=0&id=70741250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70741250",
  null
  
)

export default component.exports